import React, { useEffect, useState } from 'react';
import { HourglassIcon } from 'lucide-react';
const TOTAL_SECONDS = 22 * 60 + 22;
function useCountdown(initialSeconds: number) {
  const [seconds, setSeconds] = useState(initialSeconds);
  useEffect(() => {
    const id = setInterval(() => setSeconds(s => s > 0 ? s - 1 : 0), 1000);
    return () => clearInterval(id);
  }, []);
  return {
    mm: Math.floor(seconds / 60),
    ss: seconds % 60
  };
}
function Unit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <span className="inline-flex items-baseline gap-1.5" data-id="element-90" data-mp="k30youdzwkkr">
      <span className="font-display font-black tabular-nums tracking-wide text-white" style={{
      fontSize: '20px'
    }} data-id="element-91" data-mp="5d39qc88rqui">
        {String(value).padStart(2, '0')}
      </span>
      <span className="text-[10px] font-bold uppercase tracking-widest text-white/70 sm:text-xs" data-id="element-92" data-mp="acfsolvzsdrt">{label}</span>
    </span>;
}
export function OfferBar() {
  const {
    mm,
    ss
  } = useCountdown(TOTAL_SECONDS);
  return <div role="region" aria-label="Offer countdown" className="fixed inset-x-0 top-0 z-50 border-b-2 border-grape-soft bg-plum text-white shadow-[0_6px_24px_-8px_rgba(0,112,255,0.6)]" data-id="element-93" data-mp="1dayfrrgr6lg">
      <div className="mx-auto flex max-w-5xl items-center justify-between gap-4 px-4 py-3 sm:px-6" style={{
      paddingTop: '5px',
      paddingBottom: '6px',
      width: '374px',
      height: '40px',
      paddingRight: '35px'
    }} data-id="element-94" data-mp="10xhrkyx8z5dp">
        <p className="flex items-center gap-2.5 font-extrabold uppercase leading-tight tracking-[0.18em]" data-id="element-95" data-mp="88kgbfrge8ug">
          <HourglassIcon className="shrink-0 text-grape-soft" aria-hidden="true" style={{
          width: '17px',
          height: '19px'
        }} data-id="element-96" data-mp="3a97n8cwa4dt" />
          <span style={{
          fontSize: '9px'
        }} data-id="element-97" data-mp="hzf62u3wrqkn">Offer expires in:</span>
        </p>

        <p className="flex shrink-0 items-baseline gap-1.5 sm:gap-2.5" data-id="element-98" data-mp="d7nc09ljn2pr">
          <Unit value={mm} label="Min" data-id="element-99" data-mp="3lnqkghkhcvf5" />
          <span className="text-xl font-black text-grape-soft" data-id="element-100" data-mp="3lmp01mhkqwkr">:</span>
          <Unit value={ss} label="Sec" data-id="element-101" data-mp="3gp5juh1bg9q6" />
        </p>
      </div>
    </div>;
}